/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiDocsReadGet } from '../fn/docs/api-docs-read-get';
import { ApiDocsReadGet$Params } from '../fn/docs/api-docs-read-get';
import { apiDocsSearchGet } from '../fn/docs/api-docs-search-get';
import { ApiDocsSearchGet$Params } from '../fn/docs/api-docs-search-get';
import { DocsReadResult } from '../models/docs-read-result';
import { DocsSearchResult } from '../models/docs-search-result';


/**
 * Public documentation reader for the AI assistant. The docs site is built
 * with Fumadocs (Next.js + MDX) and exposes a search endpoint at
 * `/api/search`. Workflow:
 * <list type="number"><item><description>M:AspNetBackend.API.Controllers.DocsController.Search(System.String,System.String,System.Threading.CancellationToken) by user's question → get matching pages with snippets</description></item><item><description>M:AspNetBackend.API.Controllers.DocsController.Read(System.String,System.Threading.CancellationToken) a specific URL when full content is needed</description></item></list>
 */
@Injectable({ providedIn: 'root' })
export class DocsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiDocsSearchGet()` */
  static readonly ApiDocsSearchGetPath = '/api/Docs/search';

  /**
   * Searches the documentation via the Fumadocs Orama search endpoint.
   * Returns matched pages with title/url and matching text snippets.
   * Use this FIRST before calling M:AspNetBackend.API.Controllers.DocsController.Read(System.String,System.Threading.CancellationToken) — it's faster and
   * gives you the relevant fragments without downloading full pages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocsSearchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocsSearchGet$Response(params?: ApiDocsSearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DocsSearchResult>> {
    const obs = apiDocsSearchGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Searches the documentation via the Fumadocs Orama search endpoint.
   * Returns matched pages with title/url and matching text snippets.
   * Use this FIRST before calling M:AspNetBackend.API.Controllers.DocsController.Read(System.String,System.Threading.CancellationToken) — it's faster and
   * gives you the relevant fragments without downloading full pages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDocsSearchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocsSearchGet(params?: ApiDocsSearchGet$Params, context?: HttpContext): Observable<DocsSearchResult> {
    const resp = this.apiDocsSearchGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocsSearchResult>): DocsSearchResult => r.body)
    );
  }

  /** Path part for operation `apiDocsReadGet()` */
  static readonly ApiDocsReadGetPath = '/api/Docs/read';

  /**
   * Fetches a documentation page by URL and returns its plain-text content
   * (HTML tags stripped, scripts/styles removed). Use this after
   * M:AspNetBackend.API.Controllers.DocsController.Search(System.String,System.String,System.Threading.CancellationToken) to read a specific page fully.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDocsReadGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocsReadGet$Response(params?: ApiDocsReadGet$Params, context?: HttpContext): Observable<StrictHttpResponse<DocsReadResult>> {
    const obs = apiDocsReadGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Fetches a documentation page by URL and returns its plain-text content
   * (HTML tags stripped, scripts/styles removed). Use this after
   * M:AspNetBackend.API.Controllers.DocsController.Search(System.String,System.String,System.Threading.CancellationToken) to read a specific page fully.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiDocsReadGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDocsReadGet(params?: ApiDocsReadGet$Params, context?: HttpContext): Observable<DocsReadResult> {
    const resp = this.apiDocsReadGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DocsReadResult>): DocsReadResult => r.body)
    );
  }

}
